/** The currency a page shows. A product's Stripe price is based on the dollar and carries a fixed `eur` option. */
export type DisplayCurrency = 'eur' | 'usd'

export const CURRENCY_SYMBOL: Record<DisplayCurrency, string> = {eur: '€', usd: '$'}

/**
 * Countries whose local currency is the euro: the twenty eurozone members and the states that use
 * it without membership. Checkout charges the price's fixed `eur` option to a buyer in one of them;
 * everyone else is charged the dollar base, which Adaptive Pricing converts to the buyer's own
 * currency. The page says what a buyer here will see charged.
 */
const EURO_COUNTRIES: ReadonlySet<string> = new Set([
    'AT', 'BE', 'BG', 'HR', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'SK', 'SI', 'ES', // the eurozone
    'AD', 'MC', 'SM', 'VA', 'ME', 'XK', // the euro without membership
])

/**
 * The currency this request's page shows. CloudFront sets `CloudFront-Viewer-Country` (the product's
 * distribution forwards it: `forward_viewer_country`); without it — dev, local — the dollar, the base
 * of the price.
 */
export function displayCurrency(request: Request): DisplayCurrency {
    const country = request.headers.get('cloudfront-viewer-country')?.trim().toUpperCase()
    return country && EURO_COUNTRIES.has(country) ? 'eur' : 'usd'
}
